import React from "react";
import PropTypes from "prop-types";
// import { Dropdown } from 'primereact/dropdown';
import { InputText, Label, Dropdown } from "../../../../components/Inputs";
import MediaUploadForm from "../../../../components/MediaUploadForm";

function TechKeyForm({
  forwardedRef,
  className = "",
  model = {
    company_id: "",
    number: "",
    path: "",
  },
  techKeys = [],
  disabled,
}) {
  const mediaFormRef = React.useRef(null);
  const [state, setState] = React.useState({
    // product_id: model.product_id || '',
    number: model.number || "",
    error: {
      // product_id: null,
      number: null,
    },
  });

  const validate = React.useCallback(() => {
    const { error, ...others } = state;
    let currentModel = { ...others };
    // check if all values are set
    let isValid = true;
    Object.keys(currentModel).forEach((key) => {
      if (error[key] && currentModel[key] === "") {
        error[key] = true;
        isValid = false;
      }
    });
    if (!isValid) {
      setState((prev) => ({ ...prev, error }));
      return null;
    }
    // file (optional)
    const media = mediaFormRef.current.getModel();
    if (media.media.length > 0) {
      currentModel.path = media.media[0].path;
    }
    // techKey id
    const found = techKeys.find((item) => item.number === currentModel.number);
    if (found) {
      currentModel.techKeyId = found.id;
    }
    const { id, index, company_id } = model;
    return { id, index, company_id, ...currentModel };
  }, [model, state, techKeys]);

  const getModel = React.useCallback(() => validate(), [validate]);
  React.useImperativeHandle(forwardedRef, () => ({ getModel }));

  const { number, error } = state;
  const KeyOptions = techKeys.map((item) => ({
    label: `${item.number}`,
    value: item.number,
  }));
  const files = model.path && model.path !== "" ? [{ path: model.path }] : [];

  return (
    <div className={className}>
      <div className="neg-margin-lr">
        <div className="w3-row pad-top-">
          <div className="w3-col s6 pad-lr">
            <div
              className={`${error.issuer ? "error-group" : ""}`}
              style={{ minHeight: "200px" }}
            >
              <Label htmlFor="number">{`Schließmittel*`}</Label>
              <Dropdown
                id="number"
                className="w3-block w3-border"
                value={number}
                placeholder="Bitte auswählen"
                options={KeyOptions}
                onChange={(event) => {
                  const value = event.value;
                  setState((prev) => ({ ...prev, number: value }))
                }
                }
                disabled={disabled}
                showClear
              />
            </div>
          </div>
          <div className="w3-col s6 pad-lr">
            <div className="" style={{ minHeight: "150px" }}>
              <Label>{`Übergabevereinbarung`}</Label>
              <MediaUploadForm
                ref={mediaFormRef}
                model={{ files }}
                uploadBtnClassName=""
                uploadUrl="/data-api/media/upload?target=company"
                itemColClassName="w3-col s6"
                readOnly={disabled}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

TechKeyForm.propTypes = {
  className: PropTypes.string,
  model: PropTypes.shape({}),
  techKeys: PropTypes.array,
  disabled: PropTypes.bool,
};

export default React.forwardRef((props, ref) => (
  <TechKeyForm {...props} forwardedRef={ref} />
));
